import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=6bd49a16&scoped=true&"
import script from "./Statement.vue?vue&type=script&lang=ts&"
export * from "./Statement.vue?vue&type=script&lang=ts&"
import style0 from "./Statement.vue?vue&type=style&index=0&id=6bd49a16&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd49a16",
  null
  
)

export default component.exports